import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings" }
const _hoisted_2 = { class: "content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tabs = _resolveComponent("Tabs")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header" }, "Settings", -1 /* HOISTED */)),
    _createVNode(_component_Tabs, {
      modelValue: $options.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.active) = $event)),
      class: "tabs",
      tabs: $options.tabs,
      bordered: ""
    }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
    _createElementVNode("div", _hoisted_2, [
      ($options.active === 'profile')
        ? (_openBlock(), _createBlock($setup["Profile"], { key: 0 }))
        : _createCommentVNode("v-if", true),
      ($options.active === 'integrations')
        ? (_openBlock(), _createBlock($setup["Integrations"], { key: 1 }))
        : _createCommentVNode("v-if", true),
      ($options.active === 'memory')
        ? (_openBlock(), _createBlock($setup["Memory"], { key: 2 }))
        : _createCommentVNode("v-if", true),
      ($options.is_superuser && $options.active === 'superuser')
        ? (_openBlock(), _createBlock($setup["Superuser"], { key: 3 }))
        : _createCommentVNode("v-if", true),
      ($options.is_admin && $options.active === 'admin')
        ? (_openBlock(), _createBlock($setup["Admin"], { key: 4 }))
        : _createCommentVNode("v-if", true),
      ($options.is_admin && $options.active === 'analytics')
        ? (_openBlock(), _createBlock($setup["Analytics"], { key: 5 }))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}